import React, { Component } from "react";
import { bindActionCreators } from "redux";
import { connect } from "react-redux";
import Linkify from "react-linkify";

import {nl2br} from "lib/format";
import { getMessageByID, getGoToMessageID } from "state/teachers/selectors";
import { retryPendingReply } from "state/teachers/actions";
import {openURL} from "state/app/actions";

import Highlight from "components/Highlight";
import LiveDate from "components/LiveDate";

// Map statuses to the text that should be displayed
const statusTexts = {
  sending: "Message sending...",
  failed: "Message failed. Tap to retry.",
  sent: "Message sent"
}


class Message extends Component {
  linkifyProperties = {
    onClick: (clickEvent) => {
      this.props.openURL(clickEvent.target.href);
      clickEvent.preventDefault();
    }
  }
  /**
   * onClick handler for failed messages
   */
  retryFailedMessage = () => {
    this.props.retryPendingReply(this.props.message.get("id"));
  }

  getFormattedBody = () => {
    return <Linkify properties={this.linkifyProperties}>{nl2br(this.props.message.get("body"))}</Linkify>
  }

  render() {
    
    const { message, isHighlighted } = this.props;
    const { pending, sentDate, sender, unread, timezoneOffset, status } = message.toObject();

    const classNames = [ "message" ];

    // Result will be different for pending vs normal messages
    if (pending) {

      classNames.push("message--sent-by-parent");
      classNames.push(`message--${status}`);

      // Failed messages should retry on click
      let onClick = null;
      if (status === "failed") {
        onClick = this.retryFailedMessage;
      }

      return (
        <div className={classNames.join(" ")}>
          <div className="message__header">
            <div className="message__status">{statusTexts[status]}</div>
          </div>
          <div className="message__body" onClick={onClick}>{this.getFormattedBody()}</div>
        </div>
      );

    } else {

      classNames.push(`message--sent-by-${sender}`);
      if (unread) {
        classNames.push("message--unread");
      }

      return (
        <div className={classNames.join(" ")} ref={this.props.innerRef}>
          <div className="message__header">
            <div className="message__sent-date">
              <LiveDate date={sentDate} timezoneOffset={timezoneOffset} />
            </div>
            {unread ? <div className="message__unread-indicator">New!</div> : null}
          </div>
          <Highlight cssModifier="teachers" isHighlighted={isHighlighted}>
            <div className="message__body">{this.getFormattedBody()}</div>
          </Highlight>
        </div>
      );

    }

  }

}

export default connect(
  (state, { messageID }) => ({
    message: getMessageByID(state, messageID),
    isHighlighted: getGoToMessageID(state) === messageID
  }),
  (dispatch) => bindActionCreators({
    retryPendingReply,
    openURL
  }, dispatch)
)(Message);



// WEBPACK FOOTER //
// ./src/components/teachers/messages/Message.js